import Vue from "vue";
import App from "./App.vue";
import router from "@/router"; // api: https://github.com/vuejs/vue-router
import store from "@/store";
import i18n from "@/locales/i18n";
import { getQueryParams } from "@/utils";
import cloneDeep from "lodash/cloneDeep";
import "@/assets/iconfont/iconfont.js";
import Clipboard from "v-clipboard";
import VueCookie from "vue-cookie";
import RouteStack from "@/utils/RouteStack.js";
import httpRequest from "@/utils/httpRequest";
import eventBus from "@/utils/eventBus.js";
import { isAuth } from "./utils";
import { Message } from "element-ui";
import "@/icons";
import "./element";
import Avue from "@smallwei/avue"; // api: https://avue.top
import "@smallwei/avue/lib/index.css";

import "@/assets/scss/index.scss";
import {
  initSaleCfg,
  getCFGQudaoName,
  getCFGQudaoList,
  getCFGCurrencyList,
  getCFGRetailTypeCny,
  getCFGwechatDistMode,
  retailSysUserIdCfg,
  getSysSpecName,
  getSysImageAddr,
} from "@/utils/channelcfg";

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG = {
  storeState: cloneDeep(store.state),
  resourcesUrl: "https://img.shop.alinkone.com/",
};
// url特定参数下点击复制语言包key功能
if (getQueryParams().get("debugALinkOneLang")) {
  document.addEventListener("click", (e) => {
    const text = e.target?.textContent?.trim();
    if (text && text.startsWith("[") && text.includes("]")) {
      const key = text.substring(1, text.indexOf("]"));
      navigator.clipboard.writeText(key).then(() => {
        Message.success(`已复制 Key: ${key}`);
      });
    }
  });
}
Vue.use(Clipboard);
Vue.use(Avue);
Vue.use(VueCookie);
// 挂载全局
Vue.prototype.$routeStack = new RouteStack(); // 路由缓存
// 挂载到vue实例中
Vue.prototype.$http = httpRequest; // ajax请求方法
Vue.prototype.$eventBus = eventBus;
Vue.prototype.isAuth = isAuth; // 权限方法
Vue.prototype.initSaleCfg = initSaleCfg;
Vue.prototype.getCFGQudaoName = getCFGQudaoName;
Vue.prototype.getSysImageAddr = getSysImageAddr;
Vue.prototype.getCFGQudaoList = getCFGQudaoList;
Vue.prototype.getCFGCurrencyList = getCFGCurrencyList;
Vue.prototype.getCFGRetailTypeCny = getCFGRetailTypeCny;
Vue.prototype.getCFGwechatDistMode = getCFGwechatDistMode;
Vue.prototype.retailSysUserIdCfg = retailSysUserIdCfg;
Vue.prototype.getSysSpecName = getSysSpecName;
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.silent = false; // 显示所有警告

// TODO 临时处理警告
Vue.config.warnHandler = function (msg, vm, trace) {
  // 忽略 __ob__ 相关警告
  if (msg.includes("__ob__")) return;
  if (msg.includes("__v_isRef")) return;
  if (msg.includes("active")) return;

  // 其他警告正常输出到控制台
  console.warn(msg, vm, trace);
};
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
